import {
    useQueryClient,
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRuleSet } from '../../interfaces'
import { deleteRule } from '../../../../services/dtServices'

export const useDeleteRule = (
    orgId: string,
    ruleSetId: string,
    entityId: string,
): UseMutationResult<Awaited<ReturnType<typeof deleteRule>>, Error, string> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (ruleId: string) => {
            return deleteRule(orgId, ruleId)
        },

        // client side optimistic update
        onMutate: (ruleId: string) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (ruleSets: any) =>
                    ruleSets?.data?.map((ruleSet: IRuleSet) =>
                        ruleSet.id === ruleSetId
                            ? {
                                  ...ruleSet,
                                  rules: ruleSet.rules.filter(
                                      (rule: any) => rule.id !== ruleId,
                                  ),
                              }
                            : ruleSet,
                    ),
            )
        },
        // refetch rules after mutation
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
